import InfoCircleIcon from 'assets/icons/infoCircle.svg';
import { useContext, useEffect, useState } from 'react';
import { StoreContext, ImportSectionEnum } from 'models/import';
import useResize from 'hooks/useResize';
import InfoSteps, { InfoStepsItem } from 'components/infoSteps';
import InfoBox from 'components/infoBox';
import parse from 'html-react-parser';

export interface InstructionsProps {
  stepsRef: HTMLDivElement | null;
  sectionRef: HTMLDivElement | null;
}

function ImportPlatformInstructions(props: InstructionsProps) {
  const { stepsRef, sectionRef } = props;
  const [topPosition, setTopPosition] = useState(0);
  const [instructions, setInstructions] = useState<string | InfoStepsItem[] | undefined>(undefined);
  const { activeSection } = useContext(StoreContext);
  const { windowWidth, windowHeight } = useResize();

  const getTopPosition = (ref: HTMLDivElement | HTMLFormElement) => {
    if (!ref) {
      setTopPosition(0);
    } else if (ref && stepsRef && sectionRef) {
      const refOffset = ref.getBoundingClientRect().top + window.scrollY;
      const sectionRefOffset = sectionRef.getBoundingClientRect().top + window.scrollY;
      const stepsRefHeight = stepsRef.getBoundingClientRect().height;

      setTopPosition(refOffset - stepsRefHeight - sectionRefOffset);
    }
  };

  useEffect(() => {
    if (activeSection && activeSection.ref && activeSection.instructions) {
      getTopPosition(activeSection.ref as HTMLDivElement | HTMLFormElement);
      setInstructions(activeSection.instructions);
    }
  }, [activeSection, windowWidth, windowHeight]);

  if (!activeSection) return (null);

  return (
    <div className="ct_instructions" style={{ marginTop: `${activeSection.data !== ImportSectionEnum.SUCCESS_API ? topPosition : 0}px` }}>
      {instructions && typeof instructions === 'string' && parse(instructions)}

      {activeSection.data === ImportSectionEnum.OPTIONS && instructions && typeof instructions !== 'string' && (
        <InfoBox title="Instructions for Options" icon={<InfoCircleIcon />}>
          <InfoSteps items={instructions} />
        </InfoBox>
      )}
    </div>
  );
}

export default ImportPlatformInstructions;
